import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';
import { Cell } from 'react-table';
import { useUpdatePlayerStatsMutation } from '../../../app/api';
import { useEventStatsConfig } from '../../../hooks/useEventStatsConfig';
import { PlayerStats, UpdatePlayerStats } from '../../../types';
import { STAT_KEYS } from '../../../types/dto';

interface OverrideScoreFieldInputProps {
  cell: Cell<PlayerStats>;
  triggerRefetch: () => void;
}

export const OverrideScoreFieldInput: React.FC<
  OverrideScoreFieldInputProps
> = ({ cell, triggerRefetch }) => {
  const [updatePlayerStats] = useUpdatePlayerStatsMutation();
  const { enabled } = useEventStatsConfig();
  return (
    <NumberInput
      value={(cell.row.original as any)[cell.column.id]}
      min={0}
      onChange={(value) => {
        if (value === '' || parseInt(value) <= 0) {
          return;
        }
        const stats: UpdatePlayerStats = {};
        STAT_KEYS.forEach((k) => {
          if (enabled.has(k)) {
            stats[k] = (cell.row.original as any)[k];
          }
        });
        (stats as any)[cell.column.id] = parseInt(value);
        updatePlayerStats({
          id: cell.row.original.id,
          stats,
        }).then(() => {
          triggerRefetch();
        });
      }}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
};
